import React, { useEffect, useState } from "react";
import { Card, CardBody, Container, Row, Spinner } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Link } from "react-router-dom";
import { getSellerWithdrawals } from "../../../api/ecommerce";
import { toast, ToastContainer } from "react-toastify";

const WithDrawVendor = () => {
  const [withdrawdata, setWithdrawData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Sellers Withdraws | TopCoinLand";
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getSellerWithdrawals()
      .then((rows) => {
        if (!cancelled) setWithdrawData(Array.isArray(rows) ? rows : []);
      })
      .catch((err) => {
        if (!cancelled) {
          setWithdrawData([]);
          toast.error(err?.error || err?.message || "Failed to load withdrawal requests");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const formatAmount = (row) => {
    const c = row.currency || "GBP";
    const sym = c === "GBP" ? "£" : c === "EUR" ? "€" : c + " ";
    return `${sym}${Number(row.amount || 0).toFixed(2)}`;
  };

  const displayName = (row) =>
    row.company_name?.trim() ||
    row.seller_full_name?.trim() ||
    `${row.first_name || ""} ${row.last_name || ""}`.trim() ||
    row.seller_email ||
    "—";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Sellers Withdraws" pageTitle="Seller" />
          <Row>
            <Card>
              <CardBody>
                <div className="listjs-table" id="customerList">
                  <Row className="align-items-center gy-3">
                    <div className="col-sm">
                      <h5 className="card-title mb-0 py-3">Withdrawals</h5>
                      <p className="text-muted mb-0 small">
                        Review vendor payout requests. Open a row to update status and payment reference.
                      </p>
                    </div>
                  </Row>

                  {loading ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" /> Loading...
                    </div>
                  ) : (
                    <div className="table-responsive table-card mt-3 mb-1">
                      <table className="table align-middle table-nowrap" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th className="sort">Id</th>
                            <th className="sort">Seller</th>
                            <th className="sort">Amount</th>
                            <th className="sort">Request Date</th>
                            <th className="sort">Status</th>
                            <th className="sort">Operations</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {withdrawdata.length === 0 ? (
                            <tr>
                              <td colSpan={6} className="text-center text-muted py-4">
                                No withdrawal requests yet. Sellers can submit requests (or run DB migration and
                                create via API).
                              </td>
                            </tr>
                          ) : (
                            withdrawdata.map((item) => (
                              <tr key={item.id}>
                                <td className="id">{item.id}</td>
                                <td className="name">{displayName(item)}</td>
                                <td className="amount">{formatAmount(item)}</td>
                                <td className="requestDate">
                                  {item.created_at
                                    ? new Date(item.created_at).toLocaleString()
                                    : "—"}
                                </td>
                                <td className="status">
                                  <span
                                    className={`badge ${
                                      item.status === "approved"
                                        ? "bg-success"
                                        : item.status === "rejected" || item.status === "cancelled"
                                          ? "bg-danger"
                                          : item.status === "processing"
                                            ? "bg-info"
                                            : "bg-warning"
                                    }`}
                                  >
                                    {item.status || "pending"}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <Link
                                      to={`/vendor-withdraw-request/${item.id}`}
                                      className="btn btn-sm btn-success edit-item-btn"
                                    >
                                      <i className="ri-edit-line"></i>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
      <ToastContainer position="top-right" autoClose={4000} />
    </React.Fragment>
  );
};

export default WithDrawVendor;
